module.exports = __webpack_public_path__ + "img/daren_en1.bb76e269.jpg";